const initState = {
  chunks: 0,
};

const ContestReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_PERCENTAGE":
      return { ...state, chunks: action.payload };
    default:
      return state;
  }
};

export default ContestReducer;
